import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import AssignmentIcon from '@material-ui/icons/Assignment';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import React from 'react';
import ProcessTypeSelect from '../../UI/ProcessTypeSelect';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

export default function StatusTable({ data }) {
	const classes = useStyles();

	return (
		<ExpansionPanel style={{ marginBottom: '15px' }}>
			<ExpansionPanelSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel1a-content"
				id="panel1a-header"
			>
				<Typography variant="h6"><strong>Status</strong></Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails><TableContainer component={Paper} className={classes.padding}>
				<Table className={classes.table} aria-label="simple table" size="small">
					<TableBody>
						<TableRow>
							<TableCell align="left">
								<strong>Status</strong>
							</TableCell>
							<TableCell align="right">
								Auction
							</TableCell>
							<TableCell />
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Date Launched</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.dateLaunch}</TableCell>
							<TableCell />
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Last date for bids</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.lastBid}</TableCell>
							<TableCell>
								<Tooltip title="Edit" aria-label="edit">
									<IconButton color="inherit" aria-label="menu">
										<EditIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>NDAs signed</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.ndas}</TableCell>
							<TableCell>
								<Tooltip title="Report" aria-label="report">
									<IconButton color="inherit" aria-label="menu">
										<AssignmentIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Teaser views</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.teasers}</TableCell>
							<TableCell>
								<Tooltip title="Report" aria-label="report">
									<IconButton color="inherit" aria-label="menu">
										<AssignmentIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>IM views</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.ims}</TableCell>
							<TableCell>
								<Tooltip title="Report" aria-label="report">
									<IconButton color="inherit" aria-label="menu">
										<AssignmentIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Site visit requests</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.siteVisits}</TableCell>
							<TableCell>
								<Tooltip title="View" aria-label="view">
									<IconButton color="inherit" aria-label="menu">
										<VisibilityIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>LOIs received</strong>
							</TableCell>
							<TableCell align="right">{!!data && data.status.lois}</TableCell>
							<TableCell>
								<Tooltip title="View" aria-label="view">
									<IconButton color="inherit" aria-label="menu">
										<VisibilityIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Highest bid</strong>
							</TableCell>
							<TableCell align="right">£{!!data && data.status.bidHigh.toLocaleString()}</TableCell>
							<TableCell>
								<Tooltip title="View" aria-label="view">
									<IconButton color="inherit" aria-label="menu">
										<VisibilityIcon style={{ fontSize: '16px' }} color="primary" />
									</IconButton>
								</Tooltip>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">
								<strong>Lowest bid</strong>
							</TableCell>
							<TableCell align="right">£{!!data && data.status.bidLow.toLocaleString()}</TableCell>
							<TableCell />
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}

const useStyles = makeStyles({
	table: {
		width: '100%',
	},
	padding: { padding: '15px' },
});
